if (!window.LbtCartArtworkUpload) {
  window.LbtCartArtworkUpload = true;

  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const validShopifyFileUrl = (value) => {
    if (typeof value !== 'string' || !value.trim() || /fakepath/i.test(value)) return false;
    try {
      return new URL(value).hostname.toLowerCase() === 'cdn.shopify.com';
    } catch (error) {
      return false;
    }
  };

  const setStatus = (root, message, isError) => {
    const status = root.querySelector('[data-lbt-artwork-status]');
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('lbt-cart-artwork__status--error', Boolean(isError));
  };

  const removeLine = async (key) => {
    const response = await fetch(shopRoot + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (!response.ok) throw new Error('Could not replace the original cart line.');
    return response.json();
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-lbt-artwork-input]');
    if (!input) return;

    const root = input.closest('[data-lbt-cart-artwork]');
    const button = root && root.querySelector('[data-lbt-artwork-submit]');
    const file = input.files && input.files[0];

    if (button) button.disabled = !file;
    setStatus(root, file ? 'Selected: ' + file.name : '', false);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lbt-artwork-submit]');
    if (!button) return;

    const root = button.closest('[data-lbt-cart-artwork]');
    const input = root.querySelector('[data-lbt-artwork-input]');
    const file = input.files && input.files[0];

    if (!file) {
      setStatus(root, 'Please select a file first.', true);
      return;
    }

    const oldKey = root.dataset.lineKey;
    const addData = new FormData();
    addData.append('id', root.dataset.variantId);
    addData.append('quantity', root.dataset.quantity || '1');

    const sellingPlan = root.dataset.sellingPlan;
    if (sellingPlan) addData.append('selling_plan', sellingPlan);

    root.querySelectorAll('[data-lbt-property]').forEach((field) => {
      addData.append(field.name, field.value);
    });

    addData.set('properties[Logo / artwork file]', file);
    addData.set('properties[_Artwork file name]', file.name);

    button.disabled = true;
    input.disabled = true;
    setStatus(root, 'Uploading ' + file.name + '…', false);

    let addedLine;

    try {
      const addResponse = await fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: addData
      });
      addedLine = await addResponse.json();

      if (!addResponse.ok || addedLine.status) {
        throw new Error(addedLine.description || 'Shopify could not attach the file.');
      }

      const artworkUrl = addedLine.properties && addedLine.properties['Logo / artwork file'];
      if (!validShopifyFileUrl(artworkUrl)) {
        if (addedLine.key) await removeLine(addedLine.key);
        throw new Error('Shopify did not return a secure artwork link. Please select the file again.');
      }

      await removeLine(oldKey);
      setStatus(root, 'Artwork attached: ' + file.name, false);
      window.location.assign(shopRoot + 'cart');
    } catch (error) {
      console.error(error);
      setStatus(root, error.message || 'The artwork could not be attached. Please try again.', true);
      button.disabled = false;
      input.disabled = false;
    }
  });
}
